module.exports = __webpack_public_path__ + "img/Pinguine.d121a0d7.jpg";